import React from 'react';
import LegalPage, { LegalSection, LegalList } from '../components/LegalPage';

const Privacy: React.FC = () => {
  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated="June 13, 2026"
      intro="This Privacy Policy explains what information BlockBoard collects, how it is used, and the choices you have. BlockBoard is built around a minimum-data-collection philosophy."
    >
      <LegalSection title="Minimum Data Collection">
        <p>BlockBoard collects only the minimum information necessary to operate the platform.</p>
      </LegalSection>

      <LegalSection title="Information We Do Not Collect">
        <p>BlockBoard does not collect:</p>
        <LegalList
          items={[
            'Social Security Numbers',
            "Driver's license numbers",
            'Banking credentials',
            'Credit reports',
            'Criminal background reports',
            'Employment verification data',
            'Tenant screening information',
          ]}
        />
      </LegalSection>

      <LegalSection title="Payment Information">
        <p>
          Payment information is processed by third-party payment processors and BlockBoard does
          not store full card or bank account information.
        </p>
      </LegalSection>

      <LegalSection title="Your Documents">
        <p>
          Uploaded documents remain the property of the customer and are only accessible based on
          HOA and role permissions.
        </p>
      </LegalSection>

      <LegalSection title="How We Use Information">
        <p>
          The information we collect is used to provide and operate the platform — for example, to
          authenticate users, deliver communications, generate invoices and documents, and maintain
          security and audit logs. We do not sell customer data.
        </p>
      </LegalSection>

      <LegalSection title="Data Access & Isolation">
        <p>
          Each community's data is isolated from other communities, and access within a community is
          governed by role-based permissions. See our{' '}
          <a href="/security" className="text-[#22d3ee] hover:text-[#06b6d4] font-medium">
            Security
          </a>{' '}
          page for more detail.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default Privacy;
